import React from 'react';
import './Awards.scss';
import { awardsList } from './data';

const Awards=()=>{
    return(
        <div className="shared-awards">
            <h1>Award-winning success</h1>
            <ul>
                {awardsList.map((item) =>{
                    return(
                        <li>
                            <img src={item.logo} />
                            <p>{item.desc}</p>
                        </li>
                    )
                })}
            </ul>

        </div>
    )
};
export default Awards ;